import React, { useState } from "react";
import { Button, Select } from "./ui-kit";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export const isTemperatureRegister = (procedure) => procedure.module === "temperature" && (
  procedure.is_temperature_register === true || ["analytic", "general"].includes(procedure.temperature_mode)
  || (procedure.temperature_mode === "standard" && (procedure.name || "").toLocaleLowerCase("it").includes("temperatur"))
);
export const TEMPERATURE_MODE_LABELS = { analytic: "Analitica", general: "Check di conformità", standard: "Controllo standard" };

export default function CompanyTemperatureMode({ tenantId, procedures, savedMode, reload }) {
  const registers = procedures.filter((p) => p.active !== false && isTemperatureRegister(p));
  const modes = [...new Set(registers.map((p) => p.temperature_mode))];
  const current = modes.length === 1 ? modes[0] : savedMode || "general";
  const [draft, setDraft] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const mode = draft ?? current;
  const save = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.patch(`/admin/tenants/${tenantId}/temperature-mode`, { temperature_mode: mode });
      await reload(); setDraft(null);
      toast.success(`Modalità applicata: ${data.updated_count} procedure aggiornate. Anche le nuove useranno questa modalità.`);
    } catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || "Impossibile salvare la modalità comune"); }
    finally { setBusy(false); }
  };
  return <section aria-label="Modalità comune a tutti i reparti" className="mb-5 space-y-3 rounded-xl border border-blue-200 bg-blue-50/50 p-4">
    <h3 className="font-heading text-lg font-semibold text-navy">Modalità comune a tutti i reparti</h3>
    <p className="text-sm text-slate-600">La scelta si applica a tutti i controlli temperatura dell’azienda, in tutte le sedi e i reparti, e alle nuove procedure. Lo storico rimane conservato.</p>
    {modes.length > 1 && <p role="status" className="text-sm font-semibold text-amber-800">Sono presenti modalità diverse. Scegli quella da applicare a tutte le {registers.length} procedure temperatura.</p>}
    <label className="block text-sm font-medium text-navy">Modalità dei controlli temperatura
      <Select value={mode} disabled={busy} onChange={(e) => setDraft(e.target.value)}>{Object.entries(TEMPERATURE_MODE_LABELS).map(([key, label]) => <option key={key} value={key}>{label}</option>)}</Select>
    </label>
    {mode === "standard" && <p className="text-sm text-slate-600">Il controllo standard usa il tipo di risposta configurato per ciascuna procedura ed è disponibile in “Altri controlli”.</p>}
    {registers.some((p) => p.is_ccp) && mode === "general" && <p className="text-sm text-amber-800">Almeno una procedura è CCP: il sistema impedirà l’applicazione del check.</p>}
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    <Button type="button" variant="success" disabled={busy || !tenantId} onClick={save}>{busy ? "Applicazione…" : "Applica a tutti i reparti"}</Button>
  </section>;
}
